import { render, staticRenderFns } from "./rule10.vue?vue&type=template&id=4a4e6780&scoped=true"
import script from "./rule10.vue?vue&type=script&lang=js"
export * from "./rule10.vue?vue&type=script&lang=js"
import style0 from "./rule10.vue?vue&type=style&index=0&id=4a4e6780&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4e6780",
  null
  
)

export default component.exports